import * as React from 'react'
import Facebook from './SocialMedia/Facebook'
import Mail from './SocialMedia/Mail'
import Twitter from './SocialMedia/Twitter'

class Share extends React.Component {
  public render() {
    const url = `${window.location.protocol}//${window.location.hostname}/`

    return (
      <div className="Share">
        <h4 className="Share-title">Invitez vos proches à faire le test</h4>
        <div className="Share-icons">
          <Facebook url={url} />
          <Twitter url={url} />
          <Mail url={url} />
        </div>
      </div>
    )
  }
}

export default Share



// WEBPACK FOOTER //
// ./src/components/Share/Share.tsx